import { Doodle, DoodleFilters } from '../../../features/feature-doodles/models/interfaces/doodle.interface'
import { DoodleListParams } from '../../../features/feature-doodles/models/interfaces/doodle-list-params.interface'
import { MailingList } from '../../../features/feature-mailing-list/models/mailing-list.interface'
import { AppBasicCalendarEvent } from '../../models/interfaces/app-basic-calendar-event.interface'

export interface CalendarEventsState {
   mailingLists?: MailingList[]
   isLoadingMailingLists?: boolean
   activeMailingList?: MailingList
   isLoadingActiveMailingList?: boolean
   events?: AppBasicCalendarEvent[]
   isLoadingEvents?: boolean
   previewEvents?: AppBasicCalendarEvent[]
   isLoadingPreviewEvents?: boolean
   activeEvent?: AppBasicCalendarEvent
   isLoadingActiveEvent?: boolean
   doodles?: Doodle[]
   doodlesTotal?: number
   doodlesParams?: DoodleListParams
   isLoadingDoodles?: boolean
   doodleFilters?: DoodleFilters
   activeDoodle?: Doodle
   isLoadingActiveDoodle?: boolean
}

export const initialCalendarEventsState: CalendarEventsState = {
   mailingLists: undefined,
   events: undefined,
   previewEvents: undefined,
   doodleFilters: { type: 'all' }
}
